<template>
  <div class="history">
    <h4>{{ _.history }}</h4>
    <ul>
      <li v-for="(hval, hkey) in history" :key="hkey">
        <router-link :to="hval">
          {{ formatRoute(hval) }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['history'])
  },
  methods: {
    formatRoute(route) {
      let pieces = route.split('/');
      pieces.shift();
      let key = -1;
      return pieces.reduce((carry, pval) => {
        if (pval.match(/[a-z]/)) {
          key++;
          carry.push(this._[pval]);
        } else if (pval.match(/[0-9]/)) {
          carry[key] += ' ID: ' + pval;
        }
        return carry;
      }, []).join(', ');
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/history.scss';
</style>